<template>
  <DetailsAsideLayout>
    <template v-slot:detailsContent>
      <CreateSystem
        :tabs="tabs"
        title="Mac"
      />
    </template>
  </DetailsAsideLayout>
</template>
<script>
import { SystemCapabilitiesConsts, SystemCompatibilityConsts } from 'client/util/Constants';
import { mapState } from 'vuex';
import AgentInstructions from 'client/systems/AgentInstructions.vue';
import CreateSystem from 'client/systems/CreateSystem.vue';
import CreateSystemMixin from 'client/systems/CreateSystemMixin';
import DetailsAsideLayout from 'client/components/AsidePanel/Details/DetailsAsideLayout.vue';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';
import MdmEnrollmentInstructions from 'client/systems/MdmEnrollmentInstructions.vue';

export default {
  name: 'CreateMacSystem',

  components: {
    CreateSystem,
    DetailsAsideLayout,
  },

  mixins: [
    CreateSystemMixin,
  ],

  data() {
    return {
      copyWell: {
        content: this.connectKey,
        label: 'Connect Key',
        showTooltip: true,
        tooltipLabel: 'The Connect Key provides you with a means of associating your systems with your JumpCloud organization. Each JumpCloud Administrator has a unique Connect Key; although this is not considered a secret and any Key can be used to deploy the agent to a system.',
        rows: 1,
      },
      defaultCapabilities: [
        {
          label: SystemCapabilitiesConsts.macAuthentication,
          included: true,
        },
        {
          label: SystemCapabilitiesConsts.commandDeployment,
          included: true,
        },
        {
          label: SystemCapabilitiesConsts.deviceTrust,
          included: true,
        },
        {
          label: SystemCapabilitiesConsts.policyMgmt,
          included: false,
        },
        {
          label: SystemCapabilitiesConsts.softwareMgmt,
          included: false,
        },
        {
          label: SystemCapabilitiesConsts.remote,
          included: false,
        },
        {
          label: SystemCapabilitiesConsts.zeroTouch,
          included: false,
        },
        {
          label: SystemCapabilitiesConsts.osPatchMgmt,
          included: false,
        },
      ],
      kbLinkTerminal: {
        href: KbArticleUrls.installMacAgent,
        text: 'Installing the Mac Agent from the Terminal',
      },
      remoteAgentHref: KbArticleUrls.remoteAgentInstall,
    };
  },

  computed: {
    ...mapState('SettingsModule', [
      'macAgentUrl',
    ]),
    compatibilityNotes() {
      return {
        header: 'Supported versions',
        text: SystemCompatibilityConsts.mac,
        kbLink: this.kbLink,
      };
    },
    tabs() {
      return [
        {
          component: MdmEnrollmentInstructions,
          componentProps: {
            compatibilityNotes: this.compatibilityNotes,
            system: 'mac',
          },
          title: 'Install via MDM Enrollment Profile',
        },
        {
          component: AgentInstructions,
          componentProps: {
            agentUrl: this.macAgentUrl,
            capabilities: this.defaultCapabilities,
            compatibilityNotes: this.compatibilityNotes,
            connectKey: this.connectKey,
            copyWell: this.copyWell,
            copyWellLocation: 'Mac Copy Download Link',
            downloadButtonText: 'Download Mac Agent',
            kickstart: this.kickstart,
            system: 'mac',
          },
          title: 'Install via Mac Agent',
        },
      ];
    },
  },
};
</script>
<style module>
@import './CreateSystem.css';
</style>
